import { supabase } from './supabase';

/*
 * Contexte multi-tenant KS Tech.
 * L'établissement ACTIF de la session est stocké ici (module singleton) :
 *  - propriétaire / staff : son établissement (fixé au login).
 *  - super admin : l'établissement qu'il a sélectionné dans le picker.
 *
 * tfrom(table) est le SEUL point d'accès aux tables métier : il applique
 * automatiquement le filtre etablissement_id sur select/update/delete et
 * l'injecte sur insert/upsert. La RLS (Phase 1) reste le garde-fou serveur ;
 * ce filtre explicite est indispensable pour le super admin (que la RLS
 * n'isole pas) et garantit qu'aucune requête ne fuit hors de l'établissement.
 */

// Slug d'établissement déduit du sous-domaine <slug>.kstech.fr.
// Hors vrai sous-domaine (localhost, kstech.pages.dev, previews), on autorise
// l'override ?etab=<slug> pour tester le mécanisme sans DNS (Phase 3, D4).
export function getSubdomainSlug() {
  try {
    const host = (window.location.hostname || '').toLowerCase();
    if (host.endsWith('.kstech.fr')) {
      const sub = host.split('.')[0];
      return sub && sub !== 'www' && sub !== 'app' ? sub : null;
    }
    const override = new URLSearchParams(window.location.search).get('etab');
    return override ? override.toLowerCase().trim() : null;
  } catch {
    return null;
  }
}

let _tenantId = null;
const _listeners = new Set();

export function getTenantId() { return _tenantId; }

export function setTenantId(id) {
  _tenantId = id || null;
  _listeners.forEach((fn) => { try { fn(_tenantId); } catch (e) { /* noop */ } });
}

export function onTenantChange(fn) {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}

function withTenant(rows) {
  const tid = _tenantId;
  if (Array.isArray(rows)) return rows.map((r) => ({ ...r, etablissement_id: tid }));
  return { ...rows, etablissement_id: tid };
}

// Wrapper scopé — drop-in de supabase.from() pour les tables métier.
export function tfrom(table) {
  const tid = _tenantId;
  const qb = supabase.from(table);
  return {
    select: (cols = '*', opts) => qb.select(cols, opts).eq('etablissement_id', tid),
    insert: (rows, opts) => qb.insert(withTenant(rows), opts),
    upsert: (rows, opts) => qb.upsert(withTenant(rows), opts),
    update: (values, opts) => qb.update(values, opts).eq('etablissement_id', tid),
    delete: (opts) => qb.delete(opts).eq('etablissement_id', tid),
  };
}
